import { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { ALL_IN_ONE_EVENTS, on, type CrossDomainMessage } from '@channelwill/cross-domain'
import { showNewMessage } from '@intercom/messenger-js-sdk';
import { cwreport } from '../../../cw_center/cw-report';
import { Card, BlockStack, SkeletonBodyText, SkeletonDisplayText, InlineGrid } from '@shopify/polaris';
import { getShopifyIdToken } from '../../../cw_center/getToken';
import './index.css';

const SolutionExpert = (props: any) => {

    const { domain, email } = props;

    const app = '518111167165693952'; // 中台提供

    const [shopify_domain, setShopifyDomain] = useState(domain);
    const [u_email, setUEmail] = useState(email);
    const [loading, setLoading] = useState(true);
    // 等价于原 UNSAFE_componentWillMount，在首次渲染前同步初始化
    const [searchPar] = useState(() => {
        const locals = props.location;
        return locals.search !== '' ? `&${locals.search.replace('?', '')}` : '';
    });
    const [dVersion] = useState(() => process.env.REACT_APP_ARMS_ENV);

    // 调起客服
    const openIntercomChat = useCallback((message: string) => {
        try {
            showNewMessage(message || '');
        } catch (e) { }
    }, []);

    // iframe消息事件回调
    const messageCallback = useCallback(
        (event: CrossDomainMessage) => {
            if (typeof event === 'string') {
                openIntercomChat(event)
                return
            }
            switch (event.type) {
                // 推荐应用曝光
                case ALL_IN_ONE_EVENTS.RECOMMEND_APP_EXPOSURE:
                    cwreport.report(ALL_IN_ONE_EVENTS.RECOMMEND_APP_EXPOSURE, event.data);
                    break;
                // 客服消息
                case ALL_IN_ONE_EVENTS.CUSTOMER_MESSAGE:
                    openIntercomChat(event.data.message);
                    break;
                // 鉴权回调
                case ALL_IN_ONE_EVENTS.GET_SHOPIFY_TOKEN:
                    return getShopifyIdToken();
            }
        },
        [openIntercomChat]
    )

    useEffect(() => {
        setShopifyDomain(domain);
    }, [domain]);

    useEffect(() => {
        setUEmail(email);
    }, [email]);


    useEffect(() => {
        on("all-in-one", messageCallback);
    }, []);

    // 监听加载
    const onloadIframe = () => {
        setLoading(false);
    };

    // 骨架屏
    const cardBox = <InlineGrid gap="400" columns={window.innerWidth < 768 ? 1 : 2}>
        <Card>
            <BlockStack gap={"400"}>
                <SkeletonBodyText />
                <SkeletonBodyText />
                <SkeletonBodyText />
            </BlockStack>
        </Card>
        <Card>
            <BlockStack gap={"400"}>
                <SkeletonBodyText />
                <SkeletonBodyText />
                <SkeletonBodyText />
            </BlockStack>
        </Card>
    </InlineGrid>
    const SkeltonLoadingBox = <BlockStack gap={"400"}>
        <SkeletonDisplayText size="small" />
        <SkeletonBodyText lines={1} />
        {cardBox}
        {cardBox}
        {cardBox}
        {cardBox}
        {cardBox}
        {cardBox}
    </BlockStack>

    // 遮罩层
    const shadeLoading = <div className='shade_box'>
        {SkeltonLoadingBox}
    </div>

    // 设置iframe
    const edEmail = u_email ? btoa(u_email).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '') : '';
    const urlDomain = dVersion === 'local' ? 'https://aio-apps-test.channelwill.com' : 'https://aio-apps.channelwill.com';
    const src = `${urlDomain}/?shopify_domain=${shopify_domain}&app=${app}&email=${edEmail}&has_combo=true${searchPar}`;

    // 最终页面
    const pageContent = <div className='cw_app'>
        {loading && shadeLoading}
        <div className='solution_expert'>
            {
                shopify_domain && <iframe
                    id="all-in-one"
                    className="h-screen w-full border-none"
                    title="recommended-apps"
                    src={src}
                    onLoad={onloadIframe}
                />
            }
        </div>
    </div>;

    return pageContent;
};


export default withRouter(SolutionExpert);
